var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloudX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6057_6607)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.49951 11.5007C7.49951 12.026 7.60298 12.5462 7.80399 13.0315C8.00501 13.5168 8.29965 13.9577 8.67108 14.3292C9.04252 14.7006 9.48348 14.9952 9.96878 15.1963C10.4541 15.3973 10.9742 15.5007 11.4995 15.5007C12.0248 15.5007 12.5449 15.3973 13.0302 15.1963C13.5155 14.9952 13.9565 14.7006 14.3279 14.3292C14.6994 13.9577 14.994 13.5168 15.195 13.0315C15.396 12.5462 15.4995 12.026 15.4995 11.5007C15.4995 10.9754 15.396 10.4553 15.195 9.97C14.994 9.4847 14.6994 9.04374 14.3279 8.67231C13.9565 8.30087 13.5155 8.00623 13.0302 7.80521C12.5449 7.6042 12.0248 7.50073 11.4995 7.50073C10.9742 7.50073 10.4541 7.6042 9.96878 7.80521C9.48348 8.00623 9.04252 8.30087 8.67108 8.67231C8.29965 9.04374 8.00501 9.4847 7.80399 9.97C7.60298 10.4553 7.49951 10.9754 7.49951 11.5007V11.5007Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9995 10L9.99951 13",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99951 10L12.9995 13",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3999 6.4394C15.2699 5.93233 15.0192 5.46422 14.6691 5.07497C14.3191 4.68573 13.8802 4.38689 13.3897 4.20393C12.8992 4.02098 12.3718 3.95933 11.8524 4.02424C11.3329 4.08915 10.8369 4.2787 10.4066 4.57673C10.2311 3.64344 9.79342 2.77943 9.14482 2.08578C8.49622 1.39214 7.6635 0.897543 6.74408 0.659866C5.82466 0.422188 4.85657 0.451259 3.95307 0.743676C3.04956 1.03609 2.24802 1.57976 1.64221 2.31108C1.0364 3.04239 0.651389 3.9311 0.53221 4.87324C0.413031 5.81538 0.564618 6.77197 0.969237 7.6311C1.37385 8.49023 2.01477 9.21637 2.817 9.72456C3.61922 10.2327 4.54958 10.502 5.49923 10.5007",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6057_6607"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudX);
export default __webpack_public_path__ + "static/media/cloudX.c526197e.svg";
export { ForwardRef as ReactComponent };